module.exports = __webpack_public_path__ + "static/media/atom-alt.b19aebac.svg";